import { ProjectStatuses } from 'types/enums'

/**
 * Indicates a project has just been created and the data is not yet available.
 */
export const isInitialFlow = (status: string | undefined): boolean => {
  return [
    String(ProjectStatuses.CREATED),
    String(ProjectStatuses.PREPROCESSING),
    String(ProjectStatuses.PREPROCESSING_COMPLETE),
    String(ProjectStatuses.ERROR),
    undefined,
  ].includes(status)
}
